import bannerImage from '@/assets/images/banner.png';

const BannerBackground = () => {
    return (
        <div className="position-absolute start-0 w-100"
            style={{backgroundImage: `url(${bannerImage})`,height:'20vh', top:'35vh', backgroundSize:'cover'}}>
        </div>
    )
}
export default BannerBackground;
